// extracted by mini-css-extract-plugin
export var footer = "_km-0";
export var inherit = "_km-1";
export var input = "_km-2";
export var modalContent = "_km-3";
export var quillEditor = "_km-4";
export var subtitle = "_km-5";